import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react';

import { cx } from './cx';

interface FormFieldProps {
  label: string;
  error?: string;
  htmlFor?: string;
  children: ReactNode;
}

/** Mono uppercase label + control + inline error, stacked. */
export function FormField({ label, error, htmlFor, children }: FormFieldProps) {
  return (
    <div className="rfp-field">
      <label className="rfp-field__label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {error && (
        <p className="rfp-field__error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export function TextInput({ className, invalid, ...props }: TextInputProps) {
  return (
    <input className={cx('rfp-input', invalid && 'rfp-input--invalid', className)} {...props} />
  );
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export function Select({ children, className, invalid, ...props }: SelectProps) {
  return (
    <select
      className={cx('rfp-input', 'rfp-select', invalid && 'rfp-input--invalid', className)}
      {...props}
    >
      {children}
    </select>
  );
}

export function DateInput(props: TextInputProps) {
  return <TextInput type="date" {...props} />;
}
